<template>
  <div id="HomePage">
    <!-- 轮播图 -->
    <section class="video-section index-section section" id="video-section">
      <div class="swiper-container">
        <div class="swiper-wrapper">
          <div
            class="swiper-slide"
            v-for="(item, index) in swiperList"
            :key="index"
          >
            <div
              class="video"
              :class="{ isvideo: item.bannerType === 'video' }"
            >
              <a
                class="poster"
                :style="{
                  background: 'url(' + item.imageUrl + ') no-repeat top'
                }"
              >
                <!-- <img class="video-bg" :src="item.imageUrl"  @load="bannerloadEvent"/> -->
                <div class="content banner-txt-con" :style="{ left: `${left}px` }">
                  <div class="title1">{{ item.bannerName }}</div>
                  <div class="title2">{{ item.bannerDesc }}</div>
                </div>
                <div class="icon-play" v-if="item.bannerType === 'video'">
                  <img src="@/assets/img/play.png" />
                </div>
              </a>
              <video
                v-if="item.bannerType === 'video'"
                class="videoContent"
                controls
                :poster="item.imageUrl"
                width="100%"
              >
                <source :src="item.videoUrl" type="video/mp4" width="100%" />
              </video>
            </div>
          </div>
        </div>
        <div class="swiper-pagination banner-txt-con" :style="{ left: `${left}px` }"></div>
      </div>
    </section>

    <div class="group_2 flex-row">
      <div class="group_2_box flex-between">
        <div
          class="group_3 flex-col justify-between wow slideInLeft part1-text"
          data-wow-duration="1.5s"
        >
          <div class="text-group_2 flex-col justify-between">
            <span class="paragraph_1" :class="{'en':isEn}" v-if="isEn"
              >{{ $t("home.title1") }} {{ $t("home.title2") }}</span
            >
            <span class="paragraph_1" v-else
              >{{ $t("home.title1") }}<br />{{ $t("home.title2") }}</span
            >
            <div class="text_11" 
              >{{ $t("home.label1") }}&nbsp;&nbsp;{{
                $t("home.label2")
              }}&nbsp;&nbsp;{{ $t("home.label3") }}&nbsp;&nbsp;{{
                $t("home.label4")
              }}</div
            >
          </div>
          <div
            class="text-wrapper_2 flex-col buttonhover"
            @click="routerPushEvent('/Production', '1', '2')"
          >
            <span class="text_12">{{ $t("home.learnMore") }}</span>
          </div>
        </div>
        <div class="group_4  wow slideInRight part1-img" data-wow-duration="1.5s">
          <img src="@/assets/img/home1.webp" alt="" />
        </div>
      </div>
    </div>

    <div class="group_2 flex-row group_3">
      <div class="group_2_box">
        <div class="group_4 flex-col  wow slideInLeft" data-wow-duration="1.5s">
          <img src="@/assets/img/home2.webp" alt="" />
        </div>
        <div
          class="group_3 flex-col justify-between wow slideInRight"
          data-wow-duration="1.5s"
        >
          <div class="text-group_2 home-part3-title-big">
            <div class="paragraph_1"
              >{{ $t("home.title3") }}<br />{{ $t("home.title4") }}</div
            >
            <div class="text_11" :class="{'en2':isEn}"
              >
              <span>{{ $t("home.label5") }}</span>
              <span>{{ $t("home.label6") }}</span>
              <span>{{ $t("home.label7") }}</span>
              <span>{{ $t("home.label8") }}</span>
              
              </div
            >
          </div>

        
          <div
            class="text-wrapper_2 flex-col buttonhover"
            @click="routerPushEvent('/Production', '0', '2')"
          >
            <span class="text_12">{{ $t("home.learnMore") }}</span>
          </div>
        </div>
      </div>
    </div>

    <div class="group_2 flex-row three">
      <div class="group_2_box ">
        <div
          class="group_3 flex-col justify-between wow slideInLeft part3-text"
          data-wow-duration="1.5s"
        >
          <div class="text-group_2 flex-col justify-between">
            <span class="paragraph_1" v-if="isEn"
              >{{ $t("home.title5") }}{{ $t("home.title6") }}</span
            >
            <span class="paragraph_1"  v-else
              >{{ $t("home.title5") }}<br />{{ $t("home.title6") }}</span
            >
            <div class="text_11" :class="{'en':isEn}">{{ $t("home.label9") }}</div>
          </div>
          <div
            class="text-wrapper_2 flex-col buttonhover"
            @click="routerPushEvent('/teamwork', '0', '6')"
          >
            <span class="text_12">{{ $t("home.learnMore") }}</span>
          </div>
        </div>
        <div class="group_4  wow slideInRight" data-wow-duration="1.5s">
          <img src="@/assets/img/home3.webp" alt="" />
        </div>
      </div>
    </div>

    <div id="news">
      <div class="newsbox">
        <div class="title">
          <span class="newcenter">{{ $t("home.newsTitle") }}</span>
          <div class="switch">
            <div
              class="left"
              @click="leftClickEvent"
              :class="{ active: leftClick }"
            >
              <img :src="leftClick ? left_switch_active : left_switch" />
            </div>
            <div
              class="right"
              @click="rightClickEvent"
              :class="{ active: rightClick }"
            >
              <img :src="rightClick ? right_switch_active : right_switch" />
            </div>
          </div>
        </div>
        <div class="newlistbox" :class="{ littledata: newsList.length < 3 }">
          <div
            class="newlist"
            v-for="(item, index) in newsList"
            :key="item.id + item.title + index"
          >
            <div class="imgbox">
              <img :src="item.imageUrl" />
            </div>
            <div class="bottombox">
              <div class="time">
                {{ item.showTime || item.createDate && item.createDate.slice(0, 10) }}
              </div>
              <div class="name">{{ item.title }}</div>
              <div
                class="yuedu"
                @click="newsDetailEvent(item.id, item.newsTypeId)"
              >
                {{ $t("home.readAll") }}
                <img src="@/assets/img/yuedu-right1.svg" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Swiper from "swiper";
import { fetchbannerList, fetchNewsReportList } from "@/api/index";
import left_switch from "@/assets/img/left_switch.png";
import left_switch_active from "@/assets/img/left_switch_active.png";

import right_switch from "@/assets/img/right_switch.png";
import right_switch_active from "@/assets/img/right_switch_active.png";
import { WOW } from "wowjs";
export default {
  name: "HomePage",
  data() {
    return {
      isEn: localStorage.getItem("lang") === 'EN',
      left_switch,
      left_switch_active,
      right_switch,
      right_switch_active,
      videoUrl: "",
      videoStatus: false,
      left: 0,

      swiperList: [
        // {
        //   imageUrl: require("@/assets/img/banner_2.jpg"),
        //   path: "",
        //   title: '您身边的IT专家1',
        //   content: '宣传简介宣传简介宣传简介宣传简介宣传简介宣传简介宣传简介宣传简介',
        //   bannerType: "video",
        //   videoUrl: require("@/assets/img/test.mp4")
        // },
        // {
        //   imageUrl: require("@/assets/img/banner2.jpg"),
        //   path: "",
        //   title: '您身边的IT专家1',
        //   content: '宣传简介宣传简介宣传简介宣传简介宣传简介宣传简介宣传简介宣传简介',
        // },
      ],
      newsListAll: [],
      newsList: [],
      newsIndex: 0,
      rightClick: false,
      leftClick: false,
      videoSection: null
    };
  },
  methods: {
    routerPushEvent(path, index, navIndex) {
      sessionStorage.setItem("navIndex", navIndex);
       const lang = (localStorage.getItem('lang') || 'EN').toLowerCase()
      // this.$router.push('/' + lang + path)
      let resPath = '/' + lang + path
      this.$router.push({
        path:resPath,
        query: {
          index
        }
      });
    },
    newsDetailEvent(id, newsTypeId) {
      sessionStorage.setItem('navIndex', 4)
      this.$router.push({
        name: "newsdetail",
        query: {
          id,
          newsTypeId
        }
      });
    },
    playEvent(url) {
      this.videoStatus = true;
      this.videoUrl = url;
    },
    fetchbannerData() {
      fetchbannerList({
        language: localStorage.getItem("lang") || "CN"
      }).then(({ data }) => {
        this.swiperList = data || [];
        setTimeout(() => {
          this.swiperEvent();
        });
      });
    },
    // 获取底部新闻
    fetchNewsReportData() {
      fetchNewsReportList({
        language: localStorage.getItem("lang") || "CN"
      }).then(({ data }) => {
        this.newsListAll = JSON.parse(JSON.stringify(data));
        this.newsList = data.splice(0, 3) || [];
        this.rightClick = this.newsListAll.length > 3;
        this.leftClick = false;
      });
    },
    rightClickEvent() {
      if (!this.rightClick) return;
      const data = JSON.parse(JSON.stringify(this.newsListAll));
      this.newsIndex += 1;
      this.newsList = data.splice(3 * this.newsIndex, 3) || [];
      this.rightClick = this.newsListAll.length > (this.newsIndex + 1) * 3;
      this.leftClick = true;
    },
    leftClickEvent() {
      if (!this.leftClick) return;
      const data = JSON.parse(JSON.stringify(this.newsListAll));
      this.newsIndex -= 1;
      this.newsList = data.splice(3 * this.newsIndex, 3) || [];

      this.leftClick = this.newsIndex !== 0;
      this.rightClick = true;
    },
    bannerloadEvent() {
      this.left =
        $(".header-nav").offset() && $(".header-nav").offset().left + 74;
    },
    swiperEvent() {
      var _this = this;
      _this.videoSection = new Swiper("#video-section .swiper-container", {
        autoplay: 8000,
        speed: 800,
        // loop: true,
        autoplay: true,
        observer: true, //修改swiper自己或子元素时，自动初始化swiper
        observeParents: true,
        autoplayDisableOnInteraction: false,
        pagination: {
          el: ".swiper-pagination",
          clickable: true
        },
        paginationClickable: true
      });
      _this.videoSection.on("SlideChangeStart", function() {
        $(".videoContent").hide();
        $(".poster").show();
        $(".video video")[0].pause();
        _this.videoSection.autoplay.start();
        // alert(swiper.activeIndex) //切换结束时，告诉我现在是第几个slide
      });
      $(".video").on("click", function() {
        if (!$(this).hasClass("isvideo")) return;
        if (
          $(this)
            .children(".videoContent")
            .is(":hidden")
        ) {
          $(this)
            .children(".videoContent")
            .show();
          $(this)
            .children("video")[0]
            .play();
          $(this)
            .children(".poster")
            .hide();
          _this.videoSection.autoplay.stop();
        } else {
          $(this)
            .children(".videoContent")
            .hide();
          $(this)
            .children(".poster")
            .show();
          setTimeout(() => {
            $(this)
              .children("video")[0]
              .pause();
          }, 0);
          setTimeout(() => {
            _this.videoSection.autoplay.start();
          }, 1000);
        }
      });
      // 监听视频播放
      $(".video video").on("ended", function() {
        $(this)
          .parent()
          .children(".videoContent")
          .hide();
        $(this)
          .parent()
          .children(".poster")
          .show();
        setTimeout(() => {
          // $(this).children('video')[0].pause()
          _this.videoSection.slideNext();
        }, 0);
      });
    }
  },
  mounted() {
    this.fetchbannerData();
    this.fetchNewsReportData();
    this.$nextTick(() => {
      new WOW().init();
      this.bannerloadEvent();
    });

    // S 视频 video-section
    // 第2屏轮播
  }
};
</script>
<style lang="less">
#HomePage {
  .swiper-pagination {
    text-align: left;
    padding: 40px 0 40px 70px;
    position: absolute;
    bottom: 20px;
    
    .swiper-pagination-bullet {
      background-color: #fff;
      opacity: 0.6;
    }

    .swiper-pagination-bullet-active {
      opacity: 1;
      width: 22px;
      border-radius: 20px;
    }
  }
}
</style>
<style scoped lang="less">
#video-section {
  height: 650px;
  // min-width: 1440px;
  width: 100%;
  margin: 0 auto;

  .content {
    position: absolute;
    bottom: 180px;
    color: #ffffff;

    .title1 {
      // font-size: 60px;
      font-size: 50px;
    }

    .title2 {
      
      font-size: 24px;
      opacity: 0.6;
      margin-top: 27px;
    }
  }

  .swiper-container {
    // height: 810px
    width: 100%;
  }
.swiper-wrapper{
  width: 100%;
}
  .video video {
    // height: 790px;
  }
}

.video-section .videoContent {
  display: none;
}

.video-section .video-details {
  padding: 10px;
  background: #ffffff;
  border-radius: 5px;
  box-sizing: border-box;
}

.video-section .video {
}

.video-section .poster {
  position: relative;
  display: block;
  width: 100%;
  height: 650px;
  background-size: cover;
  // background: url(../assets/img/aboutBanner.png) no-repeat top;
}

.video-section .poster:after {
  content: "";
  transition: all 0.3s;
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  // background: #000000;
  // opacity: .4;
  z-index: 1;
}

.video-section .poster .video-bg {
  display: block;
  height: 650px;
}

.video-section .poster:hover .icon-play {
  opacity: 0.5;
}

.video-section .icon-play {
  position: absolute;
  left: 100px;
  bottom: 200px;
  z-index: 2;
  width: 50px;
  height: 50px;
  transition: all 0.3s;
  opacity: 1;
  // bottom: 200px;
  //   z-index: 3;
  //   left: 82px;
  cursor: pointer;
}

/* 整体盒子 */
#HomePage {
  width: 100%;

  .flex-row {
    display: flex;
  }

  .flex-col {
    flex: 1;
  }

  #video {
    width: 1440px;
    height: 790px;
  }

  .play {
    position: absolute;
    bottom: 200px;
    z-index: 3;
    left: 82px;
    cursor: pointer;
  }

  .videoCon {
    position: absolute;
    left: 50%;
    top: 50%;
    width: 900px;
    height: 600px;
    margin-left: -450px;
    margin-top: -300px;
    background: #fff;
    z-index: 10;

    img {
      position: absolute;
      right: -38px;
      top: -35px;
      z-index: 99;
      display: block;
      cursor: pointer;
    }
  }

  #videoBox {
    position: absolute;
    width: 100%;
    height: 100%;
  }

  .three.group_2 {
    background: #f5fafe;
  }

  .group_2 {
    height: 700px;
    background: #f8f8f8;
    margin: 0 auto;
    padding-top: 114px;
    // width: 100%;

    .group_2_box {
      width: 1440px;
      margin: 0 auto;
      // padding-left: 82px;
      display: flex;
      padding: 0 82px;
      &>div{
        // width: 50%;
       
      }
      &.flex-between{
        justify-content: space-between;
      }
    }

    .text-group_2 {
      // height: 190px;
      font-size: 60px;
      line-height:70px;
      &.home-part3-title-big{ 
        .paragraph_1{ line-height:80px;}
      }
      .paragraph_1 {
        width: 480px;
        // height: 180px;
        overflow-wrap: break-word;
        color: rgba(0, 0, 0, 1);
        font-size: 40px;
        color: #000000;
        line-height: 70px;
        &.en{
          font-size: 37px;
        }
      }

      .text_11 {
        color: #8d8d8d;
        font-size: 20px;
        line-height: 28px;
        position: relative;
        //  top: -14px;
        margin-top: 14px;
    span{
      margin-right: 6px;
      display: inline-block;
    }
    &.en{
      top: 0px;
      width: 633px;
    }
    &.en2{
      top: 0px;
      width: 516px;
    }
      }
    }

    .text-wrapper_2 {
      width: 150px;
      line-height: 50px;
      background: #2db3d0;
      border-radius: 10px 10px 10px 10px;
      color: #fff;
      text-align: center;
      margin-top: 40px;

      .text_12 {
        font-size: 20px;
        cursor: pointer;
      }
    }

    .group_4 {
      width: 628px;
      height: 460px;
    }
  }

  .group_2.group_3 {
    background-color: #ffffff;

    .group_2_box {
      // background: url(../assets/img/twobg.png) no-repeat left bottom;
      // background-size:200px 586px;
    }

    .group_3 {
      margin-left: 120px;
    }
  }

  #news {
    height: 790px;
    background: #ffffff;

    .newsbox {
      width: 1440px;
      margin: 0 auto;
      padding: 80px 82px 0 81px;

      .newlistbox {
        display: flex;
        justify-content: space-between;

        &.littledata {
          justify-content: flex-start;

          .newlist {
            // margin-right: 20px;
            width: 412px;
            min-height: 440px;
          }
        }
      }

      .title {
        display: flex;
        justify-content: space-between;
        margin-bottom: 50px;

        .newcenter {
          color: #000000;
          font-size: 40px;
        }

        .switch {
          display: flex;
          justify-content: space-between;

          > div {
            margin-left: 24px;
          }

          .active {
            cursor: pointer;
          }
        }
      }
      .newlist.nomargin {
        margin: 0;
      }

      .newlist {
        background: #fafafa;
        border-radius: 8px;
        margin-right: 20px;
        width: 412px;
        height: 440px;
        overflow: hidden;
        &:last-child{
          margin-right: 0;
        }
        .imgbox {
          overflow: hidden;
        }

        > div.bottombox {
          padding: 0 23px 30px 23px;
          position: relative;
        }

        img {
          width: 412px;
          height: 232px;
          border-top-left-radius: 8px;
          border-top-right-radius: 8px;
          overflow: hidden;
          transition:all 1s;
        }
        img:hover {
          transform: scale(1.1);
        }

        .time {
          font-size: 14px;
          color: #8d8d8d;
          line-height: 24px;
          margin: 32px 0 12px 0;
        }

        .name {
          font-size: 20px;
          color: #000000;
          line-height: 28px;
          // margin-bottom: 20px;
          height: 85px;
          overflow: hidden;
          width: 100%;
          display: -webkit-box;
          overflow: hidden;
          text-overflow: ellipsis;
           /*! autoprefixer: off; */  
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 3;
        }

        .yuedu {
          color: #2db3d0;
          line-height: 24px;
          font-size: 14px;
          display: flex;
          align-items: center;
          position: absolute;
          bottom: 0;left: 23px;
          cursor: pointer;

          img {
            width: 16px;
            height: 16px;
            margin-left: 10px;
          }

          // background: url(../assets/img/yuedu-right.png) no-repeat right;
        }
      }
    }
  }







  /* 轮播图 */
  #swiper {
    height: 650px;
    position: relative;
  }

  #swiper .banner-swiper {
    width: 100%;
    height: 100%;
  }

  #swiper .banner-swiper .swiper-slide img {
    width: 100%;
    height: 100%;
  }

  #swiper .banner-swiper .swiper-slide {
    position: relative;
  }

  #swiper .banner-swiper .swiper-slide-title {
    position: absolute;
    top: 0;
    left: 0;
    z-index: 999999999;
    width: 100%;
    height: 100%;
    color: #fff;
    background: rgba(51, 51, 51, 0.534);
    text-align: center;
    line-height: 80px;
  }

  #swiper .banner-swiper .swiper-slide-title > h1 {
    font-size: 50px;
    margin-top: 12%;
  }

  #swiper .banner-swiper .swiper-slide-title > p {
    font-size: 20px;
    margin-top: 1%;
    font-weight: 700;
  }

  /* 媒体查询（手机） */
  @media screen and (max-width: 768px) {
    #swiper {
      height: 200px;
    }
  }

  /* 媒体查询（平板） */
  @media screen and (min-width: 768px) and (max-width: 996px) {
    #swiper {
      height: 400px;
    }
  }
}

#HomePage .swiper-container-horizontal > .swiper-pagination-bullets,
.swiper-pagination-custom,
.swiper-pagination-fraction {
  bottom: 50px;
  left: 100px;
  width: 100%;
  text-align: left;
  padding-left: 0;

  span {
    color: #fff;
  }
}
</style>



// WEBPACK FOOTER //
// src/view/HomePage.vue